import { render, staticRenderFns } from "./ToDos.vue?vue&type=template&id=1cc3e289"
import script from "./ToDos.vue?vue&type=script&lang=js"
export * from "./ToDos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports